export const TALENTQ_STORE_NAMES = {
  BINDING: 'binding',
  ACCOUNT: 'account',
  ACCOUNT_LIST: 'account_list',
  PROJECT: 'project',
  PROJECT_LIST: 'project_list',
  PROJECT_FORM: 'project_form',
  DICTIONARY_ASSESSMENT: 'dictionary_assessment',
  DICTIONARY_NORM_GROUPS: 'dictionary_norm_groups',
  DICTIONARY_REPORT_OPTIONS: 'dictionary_report_options',
  DICTIONARY_REPORT_SCALES: 'dictionary_report_scales',
  DICTIONARY_PDF_REPORT_TYPES: 'dictionary_pdf_report_types',
  DICTIONARY_PDF_REPORT_OPTIONS: 'dictionary_pdf_report_options'
};
